<div class="row align-items-center text-center text-md-left" style="min-height: 44px;">
    <div class="col-12 col-md-2 mb-2 mb-md-0">
        <div class="mr-2">
            {{ payment?.created_at | amLocal | amDateFormat : 'L' }}
        </div>
    </div>

    <div class="col-12 col-md-3 mb-2 mb-md-0">
        <div>
            <span class="mr-2">{{ payment?.number }}</span>
        </div>
        <div class="small">{{ payment?.description }}</div>
    </div>

    <div
        class="col-12 col-md mb-2 mb-md-0 text-right">
        <ng-container *ngIf="payment?.payment_total_amount?.currency !== payment?.total_amount?.currency">
            {{ payment?.payment_total_amount?.amount | currency: payment?.payment_total_amount?.currency }}
        </ng-container>
    </div>

    <div class="col-12 col-md-2 mb-2 mb-md-0 text-right">
        {{ payment?.total_amount?.amount | currency: payment?.total_amount?.currency }}
        <div class="small text-muted">
            <span *ngIf="payment?.exchange_rate !== 1">
                {{ 1 | currency: payment?.total_amount?.currency }}
                ≈
                {{ payment?.exchange_rate | currency: payment?.payment_total_amount?.currency : 'symbol' : '1.4-4'}}
            </span>
        </div>
    </div>

    <div *ngIf="withInvoiceDetails" class="col-12 col-md-2 mb-2 mb-md-0 text-right">
        <ng-container *ngIf="payment?.invoice_details">
            {{ payment?.invoice_details?.total_amount_applied?.amount | currency: payment?.invoice_details?.total_amount_applied?.currency }}
        </ng-container>
    </div>

    <div *ngIf="embedded" class="col-1 text-md-right">
        <a [routerLink]="['/my-portal/payments/', payment?.id]">
            <fa-icon [icon]="['far', 'search']"></fa-icon>
        </a>
    </div>
</div>
